const billingTexts = {
  billingSectionTitle: "Billing",
  billingConfigsNavLink: "Billing Configs",
  billingPricesNavLink: "Manage Prices",
  billingDepositsNavLink: "Manage Accounts",
  billingAnalyticsNavLink: "Billing Analytics",
  submenuBillingConfigGeneral: "General",
  submenuBillingServices: "Services",
  submenuBillingAnalyticsDashboard: "Dashboard",
  submenuBillingAnalyticsAccounting: "Accounting",
  submenuBillingAnalyticsPayments: "Payments",
  submenuBillingAnalyticsInvoices: "Invoices",
  billingServiceSubscriptionLabel: "Billing Subscription",
  billingDefaultDepositTypeLabel: "Default Customer Walet",
  billingInvoiceTypeLabel: "Invoice for Postpaid Customers",
  billingDefaultInvoicePayPeriodLabel: "Default Invoice Pay Period",
  currencyLabel: "Currency",
  billingUseVATTaxLabel: "Use VAT Tax",
  billingVATIncludedLabel: "Price includes VAT Tax",
  billingVATPercentLabel: "VAT Tax Percent",
  paypalCardTitle: "PayPal Payment",
  paymentMethodSeeDetails: "Configuration Details",
  clientIDHelpText: "Client ID",
  configurationOptionsTitle: "Configuration Options",
  paypalCardText: "Customers paying with PayPal method, will use their PayPal account to pay service charges, and all payments will be placed directly to Cloud Provider's PayPal account configured for this payment method.",
  regionFormFieldLabel: "Region",
  minutesUnitLabel: "Minute(s)",
  daysUnitLabel: "Day(s)",
  hoursUnitLabel: "Hour(s)",
  serviceDomainFormFieldLabel: "Service Domain",
  serviceVersionFormFieldLabel: "Service Version",
  resourceSuspendDelayFormFieldLabel: "Suspend Action Delay",
  resourceSuspendPolicyFormFieldLabel: "Suspend Action",
  resourceDeleteDelayFormFieldLabel: "Final Action Delay",
  resourceDeletePolicyFormFieldLabel: "Final Action",
  isIdentityProviderFormFieldLabel: "Is Identity Provider",
  billingServiceUpdateActionTitle: "Update Service",
  billingServiceFormFieldHelpText: "Select Openstack service, for which you want to start billing actions.",
  billingRegionFormFieldHelpText: "Select Openstack region, if your deployment supports multiple regions.",
  billingServiceVersionFormFieldHelpText: "Choose API version for selected Openstack service.",
  billingActionKeepChoiceValue: "Keep resources untuched",
  billingActionSuspendChoiceValue: "Suspend instances",
  billingActionShelveChoiceValue: "Shelve offload instances",
  billingActionDeleteChoiceValue: "Delete all paid resources",
  addBillingServiceDialogTitle: "Add New Service",
  addBillingServiceDialogDescriptionText: "Please, select Openstack service and/or region (for multi-region deployments) and provide all required details. This information is required for billing system to fetch resource usage data and make necessary calculations.",
  billingSuspendActionFormFieldHelpText: "Suspend action policy instructs billing system to perform certain action, when user is out of money (for prepaid account types) or invoice due date has passed (for postpaid account types). Different Openstack services may have different suspend policies. This action is performed after suspend action delay period has passed.",
  billingDeleteActionFormFieldHelpText: "Final action policy instructs billing system to perform certain action, when user is out of money (for prepaid account types) or invoice due date has passed (for postpaid account types) and suspend action has already performed. Different Openstack services may have different final action policies. This action is performed after final action delay period has passed.",
  billingServiceDomainFormFieldHelpText: "Provide address (domain) for Openstack service. Address must be given in the following format: https://service_domain:port_number.",
  billingSuspendPeriodFormFieldHelpText: "Suspend action delay is the time (in minutes), which will be waited before suspend action is being performed by billing system.",
  billingDeletePeriodFormFieldHelpText: "Final action delay is the time (in minutes), which will be waited before final action is being performed by billing system.",
  serviceIsIdentityProviderFormFieldHelpText: "If Openstack service is used for authentication and authorization, this checkbox must be selected. Only one Openstack service can be configured as identity provider service.",
  appCredentialsIDFormFieldHelpText: "Specify Openstack app credentials ID, which will be used for users and billing service authentication and authorization. These credentials must belong to Openstack user with Admin role, but can be limitted to only those services and endpoints, which are required to perform data fetch and perform suspend and final actions. Visit configuration portal to see exact list of required endpoints.",
  appCredentialsSecretFormFieldHelpText: "Specify Openstack app credentials secret, which will be used for users and billing service authentication and authorization. These credentials must belong to Openstack user with Admin role, but can be limitted to only those services and endpoints, which are required to perform data fetch and perform suspend and final actions. Visit configuration portal to see exact list of required endpoints.",
  appCredentialsIDFormFieldLabel: "App Credentials ID",
  appCredentialsSecretFormFieldLabel: "App Credentials Secret",
  requiredAndPositiveFormFieldError: "This field is required and must be positive integer",
  serviceUpdateDialogTitle: "Update Service Details",
  serviceDeleteDialogTitle: "Delete Service",
  serviceDeleteDialogText: "Are you sure, you want to delete this service?",
  filterByRegionNoteText: "Filter by Region",
  filterByServiceNoteText: "Filter by Service",
  filterByResourceNoteText: "Filter by Paid Resource",
  allRegionsFormFieldChoice: "All Regions",
  allServicesFormFieldChoice: "All Services",
  allResourcesFormFieldChoice: "All Resources",
  resourceFormFieldLabel: "Resource",
  configuredPricesTabTitle: "Configured Prices",
  newResourcesTabTitle: "New Resources",
  deletedResourcesTabTitle: "Deleted Resources",
  editButtonTitle: "Edit",
  saveButtonTitle: "Save",
  priceFormFieldLabel: "Price",
  ruleRangeFormFieldTitle: "Rule Range",
  instansActiveStatusNoteText: "Active Instanse Status",
  instansNotActiveStatusNoteText: "Not Active Instanse Status",
  resetFiltersTooltipText: "Reset Filters",
  noPriceTableTitle: "No Price",
  newAccountsCardTitleLabel: "New Accounts",
  todayNewAccountsLabel: "Today",
  thisWeekNewAccountsLabel: "This Week",
  thisMonthNewAccountsLabel: "This Month",
  totalAccountsCardTitleLabel: "Total Accounts",
  prepaidAccountTypeChartTitle: "Prepaid",
  postpaidAccountTypeChartTitle: "Postpaid",
  accountsStatusesCardTitleLabel: "Accounts Statuses",
  activeStatusChartLegent: "Active",
  inactiveStatusChartLegent: "Inactive",
  suspendedStatusChartLegent: "Suspended",
  deletedStatusChartLegent: "Deleted",
  autoInvoiceTypeDescription: "Auto by billing system",
  manualInvoiceTypeDescription: "Manual outside of billing system",
  balanceFormFieldLabel: "Balance",
  billingTypeFormFieldLabel: "Billing Type",
  postpaidInvoiceTypeFormFieldLabel: "If Postpaid: Invoice Type",
  postpaidInvoicePayPeriodFormFieldLabel: "Invoice Pay Period (Days)",
  accountAgeFormFieldLabel: "Account Age",
  suspendDurationFormFieldLabel: "Suspend Duration",
  activeDepositStatusText: "Active",
  inactiveDepositStatusText: "Inactive",
  prepaidDepositTypeText: "Prepaid",
  postpaidDepositTypeText: "Postpaid",
  autoInvoiceTypeText: "Automatic",
  manualInvoiceTypeText: "Manual",
  activeStatusFormFieldLabel: "Active Status",
  otherStatusFormFieldLabel: "Other Status",
  invoiceTypeFilterMenuChoiceText: "Invoice Type",
  noDataNoteTitle: 'No Data',
  incomePieChartLabel: "Income",
  taxPieChartLabel: "Tax",
  prepaidPieChartLabel: "Prepaid",
  postpaidPieChartLabel: "Postpaid",
  topNProjectsFormFieldLabel: "Top N Projects",
  projectUsagePieChartLabel: "Projects",
  incomeSummaryCardTitle: "Income Summary",
  serviceBreakdownCardTitle: "Service Breakdown",
  nTopProjectsCardTitle: "Top N Projects",
  compareUsageCardTitle: "Compare Usage",
  compareIncomeCardTitle: "Compare Income",
  usageSummaryCardTitle: "Usage Summary",
  totalHoursResourceDecription: "Total Hrs",
  firewallRulesMaxCountDescription: "Max Rules",
  pricePerHourDescription: "Price per Hour",
  totalSizeDescription: "Total Size",
  todayPaymentsCardTitle: "Today",
  thisWeekPaymentsCardTitle: "This Week",
  thisMonthPaymentsCardTitle: "This Month",
  paymentsCountCardLabel: "Payments Count",
  paymentsAmountCardLabel: "Total Amount",
  invoiceIDFilterMenuChoiceText: "Invoice ID",
  timeStampFormFieldLabel: "Time Stamp",
  paymentMethodFormFieldLabel: "Payment Method",
  invoiceIDTypeFormFieldLabel: "Invoice ID",
  amountFormFieldLabel: "Amount",
  transactionDetailsFormFieldLabel: "Transaction Details",
  billingTransactionDetailsDialogTitle: "Transaction Details",
  noDataNoteMessage: "No Transaction Data",
  priceIncludesVATTaxText: "Price includes VAT",
  priceNotIncludesVATTaxText: "Price not includes VAT",
  priceNotCountingVATTaxText: "No Tax",
  timeStampFilterChoice: "Time Stamp",
  dueDateFilterChoice: "Due Date",
  pendingStatusChartLegent: "Pending",
  paidStatusChartLegent: "Paid",
  obsoleteStatusChartLegent: "Obsolete",
  dueDateFormFieldLabel: "Due Date",
  vatTaxFormFieldLabel: "VAT Tax",
  billingActionDisableChoiceValue: "Disable all paid resources",
  addNewResourceButtonTitle: "Add New Resource",
  ruleRangeStartFormFieldLabel: "Rule Range Start",
  ruleRangeEndFormFieldLabel: "Rule Range End",
  selectNewResourceToCreateFormTitle: "Add New Resource",
  selectNewResourceToCreateFormText: "Select resource below, to create new price item.",
  firewallRuleRangeFormFieldLable: "Firewall Rule Range",
  notSupportedServiceVersionNote: "Configured API Version is not supported!",
  selectedRowsLabel: "Selected Rows:",
  rowsPerPageLabel: "Rows per page:",
  totalRowsLabel: "Total Rows",
  deselectAllButtonTooltipText: "Deselect All",
  sortButtonTooltipText: "Sort By",
  addRemoveColumnsButtonTooltipText: "Add/Remove table columns",
  actionsButtonText: "Actions",
  noDataToDisplayText: "No data to display",
  resetAllFiltersTooltipText: "Reset all filters",
  filterOptionsButtonText: "Filter options",
  searchButtonText: "Search",
  filterCustomOptionsDialogTitle: "Customize Filter Options",
  submitButtonText: "Submit",
  successResponseTitle: "Created!",
  successCreateResponseMessage: "Resource was successfully created upon your request.",
  successUpdateTitle: "Updated!",
  successUpdateResponseMessage: "Resource was successfully updated upon your request.",
  successDeleteTitle: "Deleted!",
  successDeleteResponseMessage: "Resource was successfully deleted upon your request.",
  badRequestResponseTitle: "Bad Request!",
  badRequestResponseMessage: "Unfortunately, we could not process your request. It might be due to invalid data provided.",
  forbiddenResponseTitle: "Forbidden!",
  forbiddenResponseMessage: "Unfortunately, you are not allowed to access this data.",
  notFoundResponseTitle: "Not Found!",
  notFoundResponseMessage: "Unfortunately, we could not process your request. It might be due to invalid request URL.",
  conflictResponseTitle: "Conflict!",
  conflictResponseMessage: "Unfortunately, we could not process your request. It might be due to conflict with other service or data.",
  serviceUnavailableResponseTitle: "Service Unavailable!",
  serviceUnavailableResponseMessage: "Unfortunately, we could not process your request. It seems the service is unavailable.",
  unknownResponseTitle: "Unknown Error!",
  unknownResponseMessage: "Unfortunately, we could not process your request.",
  idFormFieldLabel: "ID",
  nameFormFieldLabel: "Name",
  typeFormFieldLabel: "Type",
  urlFormFieldLabel: "URL",
  interfaceFormFieldLabel: "Interface",
  usernameFormFieldLabel: "Username",
  descriptionFormFieldLabel: "Description",
  enabledFormFieldLabel: "Enabled",
  secretFormFieldLabel: "Secret",
  unrestrictedFormFieldLabel: "Unrestricted",
  pathFormFieldLabel: "Path",
  serviceFormFieldLabel: "Service",
  methodFormFieldLabel: "Method",
  formValueYes: "Yes",
  formValueNo: "No",
  keyFormFieldLabel: "Key",
  valueFormFieldLabel: "Value",
  optionsFormFieldLabel: "Options",
  tagsFormFieldLabel: "Tags",
  requiredFormFieldError: "This field is required!",
  listFormFieldHelpText: "You can provide more than one tag, separated by comma.",
  domainFormFieldLabel: "Domain",
  parentProjectFormFieldLabel: "Parent",
  projectFormFieldLabel: "Project",
  isDomainFormFieldLabel: "Is Domain",
  defaultProjectFormFieldLabel: "Default Project",
  passwordFormFieldLabel: "Password",
  originalPasswordFormFieldLabel: "Original Password",
  confirmPasswordFormFieldLabel: "Confirm Password",
  passwordMismatchFormFieldError: "Password and confirm password mismatch!",
  doNotAskForPasswordChangeOnFirstUseFormFieldLabel: "Password change on first use",
  passwordNotExpiresFormFieldLabel: "Password never expires",
  doNotLockOutOnFailureAttemptsFormFieldLabel: "Lockout user on failed attemts",
  lockPasswordFromChangeFormFieldLabel: "Lock password from change",
  emailFormFieldLabel: "Email",
  invalidEmailFormFieldError: "Invalid email provided!",
  passwordExpiresAtFormFieldLabel: "Password expires at",
  extraFormFieldLabel: "Extra Fields",
  createTimeFormFieldLabel: "Include create time",
  createTimeHeaderLabel: "Created At",
  parentProjectFormFieldHelpText: "If parent is specified, a new project will be placed in corresponding hierarchy under parent project within the same domain, to which parent belongs.",
  userFormFieldLabel: "User",
  groupFormFieldLabel: "Group",
  roleFormFieldLabel: "Role",
  expiresAtFormFieldLable: "Expires at",
  ruleFormFieldLabel: "Rule",
  expiresAtFormFieldLabel: "Expires At",
  neverFormValue: "Never",
  vcpusFormFieldLabel: "vCPUs",
  ramFormFieldLabel: "RAM (MiB)",
  diskFormFieldLabel: "Disk (GiB)",
  ephemeralDiskFormFieldLabel: "Ephemeral Disk (GiB)",
  disabledFormFieldLabel: "Disabled",
  swapFormFieldLabel: "SWAP (MiB)",
  rxtxFactorFormFieldLabel: "RX/TX Factor",
  isPublicFormFieldLabel: "Is Public",
  accessTypeFormFieldLabel: "Access Type",
  formValuePublic: "Public",
  formValuePrivate: "Private",
  minRamFormFieldLabel: "Min RAM (MB)",
  minDiskFormFieldLabel: "Min Disk (GB)",
  disabledReasonFormFieldLabel: "Disabled Reason",
  hostFormFieldLabel: "Host",
  stateFormFieldLabel: "State",
  statusFormFieldLabel: "Status",
  updatedAtFormFieldLabel: "Updated At",
  forcedDownFormFieldLabel: "Forced Down",
  zoneFormFieldLabel: "Zone",
  progressFormFieldLabel: "Progress",
  flavorFormFieldLabel: "Flavor",
  accessIPv4FormFieldLabel: "Access IPv4",
  accessIPv6FormFieldLabel: "Access IPv6",
  addressesFormFieldLabel: "Addresses",
  imageFormFieldLabel: "Image",
  hostnameFormFieldLabel: "Hostname",
  availabilityZoneFormFieldLabel: "Availability Zone",
  sshKeyFormFieldLabel: "SSH Key",
  ipv4AddressFormFieldLabel: "IPv4 Address",
  ipv6AddressFormFieldLabel: "IPv6 Address",
  changesSinceFormFieldLabel: "Changes Since",
  filterName: "Name",
  filterEnabled: "Enabled",
  filterChoiceYes: "Yes",
  filterChoiceNo: "No",
  filterID: "ID",
  filterType: "Type",
  filterParentRegionID: "Parent Region ID",
  filterDomain: "Domain",
  filterParentProject: "Parent",
  filterIsDomain: "Is Domain",
  filterTags: "Tags",
  filterAllTags: "All Tags",
  allTagsFilterHelpText: "You may specify more than one tag, separated by comma. Records that contain all of the specified tags will be returned.",
  filterAnyTags: "Any Tags",
  anyTagsFilterHelpText: "You may specify more than one tag, separated by comma. Records that contain any of the specified tags will be returned.",
  filterNotTags: "Not All Tags",
  notTagsFilterHelpText: "You may specify more than one tag, separated by comma. Records that do not contain exactly all of the specified tags will be returned.",
  filterNotAnyTags: "Not Any Tags",
  notAnyTagsFilterHelpText: "You may specify more than one tag, separated by comma. Records that do not contain any one of the specified tags will be returned.",
  multifieldFilterHelpText: "You may combine one or more filters to build more complex filter query.",
  filterPasswordExpiresAt: "Password expires at",
  filterOperator: "Operator",
  filterChoiceLessThan: "Less than",
  filterChoiceGreaterThan: "Greater than",
  filterChoiceLessThanOrEquals: "Less than or equals",
  filterChoiceGreaterThanOrEquals: "Greater than or equals",
  filterChoiceEquals: "Equals",
  filterChoiceNotEquals: "Not equals",
  selectButtonTitleText: "Select",
  actionsDropdownLabelText: "Actions",
  applyButtonTitleText: "Apply",
  //new texts
  adminProjectSelectorTooltipText: "Select default Admin project",
  ramTableHeaderLabel: "RAM",
  diskTableHeaderLabel: "Disk",
  ephemeralTableHeaderLabel: "Ephemeral Disk",
  swapTableHeaderLabel: "SWAP",
  fingerprintFormFieldLabel: "Fingerprint",
  publicKeyFormFieldLabel: "Public Key",
  saveButtonText: "Save",
  editButtonText: "Edit",
  loadingHeader: "Loading",
  customFieldsTitleText: "Custom Fields",
  duplicateFieldsAreNotAllowedErrorText: "Duplicate fields are not allowed",
  catalogHeaderTitle: "Catalog",
  existingFieldsHeaderTitle: "Existing Fields",
  instructionBoxNoteText: "Click each item to get its description here.",
  noDescriptionText: "No Description",
  warningDialogTitle: "Warning",
  addToListButtonTitle: "Add To List",
  noProjectsSelectedNoteText: "No Project Selected",
  regionSelectorTooltipText: "Select Openstack Region",
  customersSupportNavLink: "Customers Support",
  customersNotificationsHeaderTitle: "Customers Notifications",
  issueReportAlertHeaderTitle: "Issue Report Notifications",
  projectRequestAlertHeaderTitle: "Project Request Notifications",
  limitsUpdateAlertHeaderTitle: "Limits Update Notification",
  snapshotFormFieldLabel: "Snapshot",
  backupVolSourceChoiceTitle: "Backup",
  routerFormFieldLabel: "Router",
  floatingIPFormFieldLabel: "Floating IP",
  encryptionAlgorithmFormFieldLabel: "Encryption Algorithm",
  ikePolicyFormFieldLabel: "IKE Policy",
  ipsecPolicyFormFieldLabel: "IPsec Policy",
  loadbalancerFormFieldLabel: "Loadbalancer",
}

export default billingTexts